import hoverintent from 'hoverintent';
import template from 'header/main-navigation.j2';
import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import addAccordionSupport from '../uiSupport/accordion';
import Config from '../../../core/js/configs/config.js';
import { setSelectedLevel1NavSlug, setSelectedLevel2NavSlug } from '../actions/navigationActions';
import { getNavItemSlugAtLevel, getFlatNavigationSync } from '../utils/navigationUtils';
import { getSlugFromURL } from '../utils/urlUtils';
import { getCategorySlugForProduct } from '../../../product/js/utils/utils';

const HOVER_NAV_INDICATOR_CLASS = 'has-hover-nav-showing';
const SPECIFIC_HOVER_NAV_CLASS = 'is-showing';

function addL1Hover(element, selectedLevel1Slug) {
    const hoverContainerElement = $(element).find('.js-main-navigation__ul--level-2-hover');
    const hoverL1SlugName = $(hoverContainerElement).closest('.js-level1-nav-item')
        .attr('data-slug');

    if (hoverL1SlugName !== selectedLevel1Slug) {
        $('.js-main-navigation').parent()
            .addClass(HOVER_NAV_INDICATOR_CLASS);
        $(hoverContainerElement).addClass(SPECIFIC_HOVER_NAV_CLASS);
    }
}

function addL2Hover(element) {
    const hoverContainerElement = $(element).find('.c-main-navigation__ul--level-3');
    const childSlugCount = _.toInteger($(hoverContainerElement).attr('data-child-slug-count'));

    if (childSlugCount > 0) {
        // Check if we already have an L3 list showing. If so, wait for it to close.
        const visibleL3s = $(element).siblings()
                                     .find('ul.is-showing');
        const hoverDelayMillis = (visibleL3s.length === 0) ? 0 : _.get(Config, 'mainNavigation.level2Timeout', 250);

        // eslint-disable-next-line angular/timeout-service
        window.setTimeout(function fn() {
            $(hoverContainerElement).addClass(SPECIFIC_HOVER_NAV_CLASS);
        }, hoverDelayMillis);
    }
}

function removeL2Hover(element) {
    $(element).find('.c-main-navigation__ul--level-3')
        .removeClass(SPECIFIC_HOVER_NAV_CLASS);
}

function removeL1Hover(element) {
    $('.js-main-navigation').parent()
        .removeClass(HOVER_NAV_INDICATOR_CLASS);
    $(element).find('.js-main-navigation__ul--level-2-hover')
        .removeClass(SPECIFIC_HOVER_NAV_CLASS);
}

function createDelayedRemoveHover(element, delayMs) {
    const removeL1HoverWithElem = () => {
        const hoverKeptOpen = $(element).find('.js-main-navigation__ul--level-2-hover.keep-open').length > 0;
        const l1KeepOpen = $('.js-level1-nav-item.keep-open').length > 0;
        if (!hoverKeptOpen && !l1KeepOpen) {
            removeL1Hover(element);
        }
    };

    const hoverRemoveTask = window.setTimeout(removeL1HoverWithElem, delayMs); // eslint-disable-line angular/timeout-service, max-len

    return hoverRemoveTask;
}

function addHoverIntentSupport(store) {
    const state = store.getState();
    // TODO: UW-15515 - remove when SS_UOSUPNAV test is over
    const isSuperNavTest = _.get(state, 'core.ab.SS_UOSUPNAV', false) === 1;
    const useSuperNav = _.get(state, 'core.useSuperNav', false) || isSuperNavTest;
    const elementSelector = (useSuperNav) ? '.js-navigation-item' : '.js-level1-nav-item';
    const navigationItems = document.querySelectorAll(elementSelector); // eslint-disable-line angular/document-service, max-len
    const mainNavigationArray = Array.prototype.slice.call(navigationItems);
    let hoverRemoveTask = null;

    function onOver() {
        const $this = $(this);
        const currentState = store.getState();
        const selectedLevel1Slug = _.get(currentState, 'core.selectedLevel1NavSlug');
        if (useSuperNav) {
            $this.addClass('show-supernav');
        } else {
            $('.js-main-navigation').parent()
                .removeClass(HOVER_NAV_INDICATOR_CLASS);
            $(`.js-main-navigation__ul--level-2-hover.${SPECIFIC_HOVER_NAV_CLASS}`).removeClass(SPECIFIC_HOVER_NAV_CLASS); // eslint-disable-line max-len
            if (hoverRemoveTask) {
                window.clearTimeout(hoverRemoveTask);
            }
        }
        addL1Hover($this, selectedLevel1Slug);
        $this.find('.js-supernav-promo').addClass('lazyload');
    }

    function onOut() {
        const $this = $(this);
        if (useSuperNav) {
            $(this).removeClass('show-supernav');
        } else {
            $(this).addClass(SPECIFIC_HOVER_NAV_CLASS);
            hoverRemoveTask = createDelayedRemoveHover($this, _.get(Config, 'mainNavigation.tieredHoverNav.exitTimeout', 750)); // eslint-disable-line max-len
        }
    }

    function onOverL2() {
        const $this = $(this);
        if (useSuperNav) {
            $this.addClass('show-supernav');
        } else {
            addL2Hover($this);
        }
    }

    function onOutL2() {
        const $this = $(this);
        if (useSuperNav) {
            $this.addClass('show-supernav');
        } else {
            removeL2Hover($this);
        }
    }

    const hoverIntentConfigL1 = _.cloneDeep(Config.mainNavigation);

    if (!useSuperNav) {
        const hoverIntentConfigL2 = _.cloneDeep(Config.mainNavigation);
        let level2NavArray = document.querySelectorAll('.js-level2-nav-item'); // eslint-disable-line angular/document-service, max-len
        level2NavArray = Array.prototype.slice.call(level2NavArray);

        hoverIntentConfigL1.timeout = _.get(hoverIntentConfigL1, 'tieredHoverNav.enterTimeout', 250);
        hoverIntentConfigL2.timeout = _.get(hoverIntentConfigL2, 'level2Timeout', 250);

        for (const level2 of level2NavArray) {
            hoverintent(level2, onOverL2, onOutL2).options(hoverIntentConfigL2);
        }
    }

    for (const navItem of mainNavigationArray) {
        hoverintent(navItem,
        onOver,
        onOut).options(hoverIntentConfigL1);
    }
}

/**
 * Attach hover events for L2 hover nav on tiered navigation (UO)
 * @param  {Object} store the Redux store
 * @return {undefined}
 */
function attachHoverEvents(store) {
    $('.js-main-navigation__ul--level-2-hover').hover((e) => {
        $(e.currentTarget).addClass('keep-open');
    }, (e) => {
        $(e.currentTarget).removeClass('keep-open');
    });

    $('.js-level1-nav-item').hover((e) => {
        const slideLine = $('.c-main-navigation .js-nav-slide-line');
        const hoveredNavItem = $(e.currentTarget);
        const selectedLevel1NavItem = $('.c-main-navigation .js-level1-nav-item.is-selected');

        hoveredNavItem.addClass('keep-open');
        slideLine.addClass('is-hovered');

        if (selectedLevel1NavItem.length === 0) {
            slideLine.addClass('is-shown');
        }
        setTimeout(() => {  // eslint-disable-line angular/timeout-service
            slideLine.css({
                'left': getSlideLineLeftPos(hoveredNavItem)
            });
        }, 0);
    }, (e) => {
        const slideLine = $('.c-main-navigation .js-nav-slide-line');
        const selectedLevel1NavItem = $('.c-main-navigation .js-level1-nav-item.is-selected');

        $(e.currentTarget).removeClass('keep-open');
        slideLine.removeClass('is-hovered');

        if (selectedLevel1NavItem.length === 0) {
            slideLine.removeClass('is-shown');
        } else {
            slideLine.addClass('is-shown');

            setTimeout(() => { // eslint-disable-line angular/timeout-service
                slideLine.css({
                    'left': getSlideLineLeftPos(selectedLevel1NavItem)
                });
            }, 0);
        }
    });
}

/**
 * Attach component events to DOM
 * @param {object} store The store
 * @returns {undefined}
 */
function attachEvents(store) {
    $(document).on('focus', '.js-navigation-item', (e) => {
        $(e.currentTarget).addClass('show-supernav');
    });

    $(document).on('blur', '.js-navigation-item', (e) => {
        $(e.currentTarget).removeClass('show-supernav');
    });

    $(document).on('focus', '.js-main-navigation__ul--level-2-hover', (e) => {
        $(e.currentTarget).addClass('keep-open');
    });

    $(document).on('blur', '.js-main-navigation__ul--level-2-hover', (e) => {
        $(e.currentTarget).removeClass('keep-open');
    });

    attachHoverEvents(store);

    const state = store.getState();

    $(window).on('resize', _.debounce(_.debounce((e) => {
        setSlideLineLeftPos(state);
    }, 1000)));
}

function getSlideLineLeftPos($currentItem) {
    const navWidth = $currentItem.width();
    const slideLineWidth = $('.c-main-navigation .js-nav-slide-line').width();
    const leftStartingPos = $currentItem.position().left;
    const lineOffset = (navWidth - slideLineWidth) / 2;
    return leftStartingPos + lineOffset;
}

export function firstRender(store) {
    const state = store.getState();
    const clientSideMismatchDetected = _.get(state, 'core.deviceCharacteristics.clientSideMismatch', false);

    if (clientSideMismatchDetected) {
        // since we are client rendering nav in this case, make sure we have flatNav in the store before rendering
        getFlatNavigationSync(store);
        this.render(store, this, {});
    }
}

export function afterRender(store) {
    if (_.get(store.getState(), 'core.deviceCharacteristics.is_smallish', false) ||
        _.get(store.getState(), 'core.deviceCharacteristics.is_medium', false)) {
        addAccordionSupport(this, this.templateLocation);
    } else {
        addHoverIntentSupport(store);
        attachHoverEvents(store);
    }
}

function afterConstruction(store) {
    const deviceCharacteristics = this.getDeviceCharacteristics();
    const isTouchDevice = _.get(deviceCharacteristics, 'is_touch', false);
    const isSmallOrMediumTouchDevice = isTouchDevice &&
        (_.get(deviceCharacteristics, 'is_smallish', false) || _.get(deviceCharacteristics, 'is_medium', false));

    if (!isSmallOrMediumTouchDevice) {
        addHoverIntentSupport(store);
    }
    const state = store.getState();
    setSlideLineLeftPos(state);
}

function setSlideLineLeftPos(state) {
    const slideLine = $('.c-main-navigation .js-nav-slide-line');
    const selectedLevel1NavItem = $('.c-main-navigation .js-level1-nav-item.is-selected');

    if (selectedLevel1NavItem.length > 0) {

        slideLine.addClass('is-shown');
        slideLine.css({
            'left': getSlideLineLeftPos(selectedLevel1NavItem)
        });
    }
}

export function onStateChange(store, watchValue, previous, current) {
    const state = store.getState();

    if (watchValue === 'core.loggedIn') {
        setTimeout(() => { // eslint-disable-line angular/timeout-service
            setSlideLineLeftPos(state);
        }, 0);
    } else {
        getFlatNavigationSync(store);
        this.render(store, this, {});
    }
}

function beforeConstruction(store) {
    const state = store.getState();
    // TODO: UW-15515 - remove when SS_UOSUPNAV test is over
    const isSuperNavTest = _.get(state, 'core.ab.SS_UOSUPNAV', false) === 1;
    const useSuperNav = _.get(state, 'core.useSuperNav', false) || isSuperNavTest;

    if (!useSuperNav) {
        const flatNav = _.get(state, 'core.flatNavigation');
        const contextPath = _.get(state, 'core.contextPath');
        const categoryIdToSlug = _.get(state, 'core.categoryIdToSlug', {});
        const url = window.location.href;
        let categorySlug;

        if (_.size(state.product) > 0) {
            categorySlug = getCategorySlugForProduct(state.product, categoryIdToSlug, (slug) => _.has(flatNav, slug));
        } else {
            categorySlug = getSlugFromURL(url, contextPath);
        }

        const level1Slug = getNavItemSlugAtLevel(flatNav, categorySlug, 1);
        const level2Slug = getNavItemSlugAtLevel(flatNav, categorySlug, 2);

        if (level1Slug) {
            store.dispatch(setSelectedLevel1NavSlug(level1Slug));
        }

        if (level2Slug) {
            store.dispatch(setSelectedLevel2NavSlug(level2Slug));
        }
    }
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-navigation-container',
        onStateChange: onStateChange,
        watch: ['core.deviceCharacteristics', 'core.loggedIn'],
        name: 'navigationComponent',
        template: template,
        attachEvents: attachEvents,
        jsAccordionClass: '.js-accordion',
        beforeConstruction: beforeConstruction,
        firstRender: firstRender,
        afterRender: afterRender,
        afterConstruction: afterConstruction
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
